
import React from 'react';
import { Plus } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';

interface ProfileAvatarProps {
  imageSrc: string;
  alt: string;
  fallback: string;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ imageSrc, alt, fallback }) => {
  return (
    <div className="relative mx-auto w-32 h-32">
      <Avatar className="w-32 h-32 border-4 border-background shadow-md">
        <AvatarImage src={imageSrc} alt={alt} />
        <AvatarFallback className="text-3xl">{fallback}</AvatarFallback>
      </Avatar>
      <Button 
        variant="default" 
        size="icon" 
        className="absolute bottom-0 right-0 rounded-full h-8 w-8"
      >
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ProfileAvatar;
